import { Avatar, Box, Typography } from "@mui/material";
import React from "react";
import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const MotionTypography = motion(Typography);

const reviews = [
  {
    name: "Amit Purohit",
    designation: "Student",
    body: "The course helped me build confidence in computers.",
    img: "https://avatar.vercel.sh/amit",
    course: "DCO - Diploma in Computer Operator",
  },
  {
    name: "Ravi Acharya",
    designation: "Student",
    body: "Typing ka practice daily hota tha, ab speed kaafi badh gayi hai.",
    img: "https://avatar.vercel.sh/ravi",
    course: "Hindi Typing",
  },
  {
    name: "Suman Joshi",
    designation: "Student",
    body: "WordPress seekhkar maine apni pehli website banayi.",
    img: "https://avatar.vercel.sh/suman",
    course: "Web Development (WordPress)",
  },
  {
    name: "Neeraj Vyas",
    designation: "Student",
    body: "Excel aur Word ka use ab easy lagta hai.",
    img: "https://avatar.vercel.sh/neeraj",
    course: "Basic Computer",
  },
  {
    name: "Vikas Baheti",
    designation: "Student",
    body: "The Tally course gave me practical accounting skills.",
    img: "https://avatar.vercel.sh/vikas",
    course: "Tally",
  },
  {
    name: "Manish Agrawal",
    designation: "Student",
    body: "Mujhe course ke baad ek local firm mein job mil gayi.",
    img: "https://avatar.vercel.sh/manish",
    course: "DCO - Diploma in Computer Operator",
  },
  {
    name: "Nidhi Maheshwari",
    designation: "Student",
    body: "Teachers were very supportive and professional.",
    img: "https://avatar.vercel.sh/nidhi",
    course: "Graduation Computer",
  },
  {
    name: "Kunal Rathi",
    designation: "Student",
    body: "Basics se lekar advanced tak sab kuch samajh mein aaya.",
    img: "https://avatar.vercel.sh/kunal",
    course: "Basic Computer",
  },
  {
    name: "Rohit Pareek",
    designation: "Student",
    body: "I learned to type fluently in English.",
    img: "https://avatar.vercel.sh/rohit",
    course: "English Typing",
  },
  {
    name: "Shivani Ojha",
    designation: "Student",
    body: "Classroom environment very good tha, sab doubts clear hue.",
    img: "https://avatar.vercel.sh/shivani",
    course: "11th Computer",
  },
  {
    name: "Rahul Bissa",
    designation: "Student",
    body: "The practicals helped me learn faster than theory.",
    img: "https://avatar.vercel.sh/rahul",
    course: "Web Development (MERN)",
  },
  {
    name: "Tanu Ranga",
    designation: "Student",
    body: "DSA sikh kar coding mein interest aa gaya.",
    img: "https://avatar.vercel.sh/tanu",
    course: "DSA with Java",
  },
  {
    name: "Piyush Chura",
    designation: "Student",
    body: "Best institute in Bikaner for computer education.",
    img: "https://avatar.vercel.sh/piyush",
    course: "12th Computer",
  },
  {
    name: "Bhavna Chhangani",
    designation: "Student",
    body: "Mujhe form bharna, typing aur resume banana sikhaya gaya.",
    img: "https://avatar.vercel.sh/bhavna",
    course: "DCO - Diploma in Computer Operator",
  },
  {
    name: "Suresh Bhadani",
    designation: "Student",
    body: "Now I can make websites on my own. Thank you!",
    img: "https://avatar.vercel.sh/suresh",
    course: "Web Development (WordPress)",
  },
  {
    name: "Neha Harsh",
    designation: "Student",
    body: "Typing class mein discipline aur speed dono improve hua.",
    img: "https://avatar.vercel.sh/neha",
    course: "Hindi Typing",
  },
  {
    name: "Gaurav Sewag",
    designation: "Student",
    body: "Bahut accha experience raha, staff bhi friendly tha.",
    img: "https://avatar.vercel.sh/gaurav",
    course: "Basic Computer",
  },
  {
    name: "Vinod Sharma",
    designation: "Student",
    body: "I can now manage data entry jobs confidently.",
    img: "https://avatar.vercel.sh/vinod",
    course: "Tally",
  },
  {
    name: "Jyoti Kumar",
    designation: "Student",
    body: "Ab computer ka dar bilkul khatam ho gaya hai.",
    img: "https://avatar.vercel.sh/jyoti",
    course: "DCO - Diploma in Computer Operator",
  },
  {
    name: "Ramesh Mohta",
    designation: "Student",
    body: "Great institute for beginners and job seekers.",
    img: "https://avatar.vercel.sh/ramesh",
    course: "Graduation Computer",
  },
  {
    name: "Meena Rathore",
    designation: "Student",
    body: "Courses are affordable and very effective.",
    img: "https://avatar.vercel.sh/meena",
    course: "12th Computer",
  },
  {
    name: "Nikhil Gour",
    designation: "Student",
    body: "Bahut hi practical training di gayi. Helpful tha.",
    img: "https://avatar.vercel.sh/nikhil",
    course: "Tally",
  },
  {
    name: "Rishabh Shrimali",
    designation: "Student",
    body: "I can now apply for data entry jobs confidently.",
    img: "https://avatar.vercel.sh/rishabh",
    course: "DCO - Diploma in Computer Operator",
  },
  {
    name: "Kajal Pandey",
    designation: "Student",
    body: "Online forms bharna, PDF editing sab seekh liya.",
    img: "https://avatar.vercel.sh/kajal",
    course: "Basic Computer",
  },
  {
    name: "Asha Soni",
    designation: "Student",
    body: "English typing ab fluent ho gayi hai. Practice ka fayda mila.",
    img: "https://avatar.vercel.sh/asha",
    course: "English Typing",
  },
  {
    name: "Faizan Ansari",
    designation: "Student",
    body: "The instructors were patient and supportive.",
    img: "https://avatar.vercel.sh/faizan",
    course: "Web Development (MERN)",
  },
  {
    name: "Rehana Qureshi",
    designation: "Student",
    body: "Mujhe Excel aur Tally dono achhi tarah samajh mein aaye.",
    img: "https://avatar.vercel.sh/rehana",
    course: "Tally",
  },
  {
    name: "Aarti Purohit",
    designation: "Student",
    body: "Class environment bahut friendly tha.",
    img: "https://avatar.vercel.sh/aarti",
    course: "Hindi Typing",
  },
  {
    name: "Mahesh Acharya",
    designation: "Student",
    body: "Teachers made coding easy and fun.",
    img: "https://avatar.vercel.sh/mahesh",
    course: "DSA with Java",
  },
  {
    name: "Ritu Joshi",
    designation: "Student",
    body: "Computer se dar lagta tha, ab maza aata hai.",
    img: "https://avatar.vercel.sh/ritu",
    course: "DCO - Diploma in Computer Operator",
  },
  {
    name: "Nikhil Vyas",
    designation: "Student",
    body: "The MERN stack course was career-changing.",
    img: "https://avatar.vercel.sh/nikhil",
    course: "Web Development (MERN)",
  },
  {
    name: "Pankaj Baheti",
    designation: "Student",
    body: "Bahut acchi training aur notes diye gaye the.",
    img: "https://avatar.vercel.sh/pankaj",
    course: "11th Computer",
  },
  {
    name: "Geeta Agrawal",
    designation: "Student",
    body: "Typing speed improve ho gaya. Exams mein help milegi.",
    img: "https://avatar.vercel.sh/geeta",
    course: "Hindi Typing",
  },
  {
    name: "Ravi Maheshwari",
    designation: "Student",
    body: "WordPress sikh kar freelancing start ki.",
    img: "https://avatar.vercel.sh/ravi",
    course: "Web Development (WordPress)",
  },
  {
    name: "Sneha Rathi",
    designation: "Student",
    body: "Excel aur Word pe achhi command aa gayi hai.",
    img: "https://avatar.vercel.sh/sneha",
    course: "Basic Computer",
  },
  {
    name: "Ashok Pareek",
    designation: "Student",
    body: "I now handle office work efficiently.",
    img: "https://avatar.vercel.sh/ashok",
    course: "Tally",
  },
  {
    name: "Neha Ojha",
    designation: "Student",
    body: "Very helpful course for job preparation.",
    img: "https://avatar.vercel.sh/neha",
    course: "Graduation Computer",
  },
  {
    name: "Raj Bissa",
    designation: "Student",
    body: "Classrooms clean thein, aur samjhaane ka tareeka simple tha.",
    img: "https://avatar.vercel.sh/raj",
    course: "12th Computer",
  },
  {
    name: "Swati Ranga",
    designation: "Student",
    body: "Bohot achhe se padhaya gaya, practical bhi the.",
    img: "https://avatar.vercel.sh/swati",
    course: "Basic Computer",
  },
  {
    name: "Sanjay Chura",
    designation: "Student",
    body: "Mujhe ab MS Office pe kaam karne mein confidence aata hai.",
    img: "https://avatar.vercel.sh/sanjay",
    course: "DCO - Diploma in Computer Operator",
  },
  {
    name: "Deepika Chhangani",
    designation: "Student",
    body: "Typing kaafi fast ho gayi hai. Exams ke liye useful.",
    img: "https://avatar.vercel.sh/deepika",
    course: "Hindi Typing",
  },
  {
    name: "Harshit Bhadani",
    designation: "Student",
    body: "Web development course changed my perspective.",
    img: "https://avatar.vercel.sh/harshit",
    course: "Web Development (WordPress)",
  },
  {
    name: "Sunita Harsh",
    designation: "Student",
    body: "Best teachers and learning materials.",
    img: "https://avatar.vercel.sh/sunita",
    course: "Tally",
  },
  {
    name: "Anil Sewag",
    designation: "Student",
    body: "I cracked a job interview because of this course.",
    img: "https://avatar.vercel.sh/anil",
    course: "Graduation Computer",
  },
  {
    name: "Mehul Sharma",
    designation: "Student",
    body: "Bahut kuch seekha jo school mein nahi sikhaya gaya.",
    img: "https://avatar.vercel.sh/mehul",
    course: "12th Computer",
  },
  {
    name: "Tanvi Kumar",
    designation: "Student",
    body: "Class mein har cheez clearly explain ki gayi thi.",
    img: "https://avatar.vercel.sh/tanvi",
    course: "English Typing",
  },
  {
    name: "Kavita Qureshi",
    designation: "Student",
    body: "Staff kaafi supportive tha aur doubts clear hue.",
    img: "https://avatar.vercel.sh/kavita",
    course: "Basic Computer",
  },
];

const firstRow = reviews.slice(0, reviews.length / 2);
const secondRow = reviews.slice(reviews.length / 2);

function Testimonials() {
  return (
    <Box sx={{ p: 4, backgroundColor: "#f5f5f5", borderRadius: 2 }}>
      <Box sx={{ gap: "0.8rem" }}>
        <MotionTypography
          // fontSize={{ xs: "1.9rem", sm: "2.5rem", md: "1.3rem" }}
          variant="h4"
          sx={{
            fontWeight: "bold",
            color: "#333",
            textShadow: "1px 1px 2px rgba(0,0,0,0.1)", // Subtle text shadow
            textAlign: "center",
          }}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.8,
            delay: 0.5,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          Our Students Are Buzzing About Us!
        </MotionTypography>
      </Box>
      <Box>
        <Box
          sx={{
            position: "relative",
            // height: "300px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            marginBlock: "0.8rem",
            padding: 2,
            backgroundColor: "white",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            gap: "0.8rem",
          }}
        >
          {/* First Row */}
          <Marquee pauseOnHover direction="left" duration={20}>
            {firstRow.map((review) => (
              <Box
                sx={{
                  padding: 2,
                  border: "1px solid rgba(0,0,0,0.1)",
                  borderRadius: "12px",
                  backgroundColor: "#f5f5f5",
                  minWidth: "200px",
                  width: "20rem",
                  height: "10rem",
                  overflow: "hidden",
                  marginLeft: 2,
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                  cursor: "pointer",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar
                    src={review.img}
                    alt={review.name}
                    sx={{ width: 32, height: 32 }}
                  />
                  <Box>
                    <Typography variant="subtitle1">{review.name}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {review.designation},&nbsp;{review.course}
                    </Typography>
                  </Box>
                </Box>
                <Typography
                  variant="body2"
                  sx={{ marginTop: 1, textWrap: "wrap", width: "100%" }}
                >
                  <quote>{review.body}</quote>
                </Typography>
              </Box>
            ))}
          </Marquee>
          {/* Second Row */}
          <Marquee pauseOnHover direction="right" duration={20}>
            {secondRow.map((review) => (
              <Box
                sx={{
                  padding: 2,
                  border: "1px solid rgba(0,0,0,0.1)",
                  borderRadius: "12px",
                  backgroundColor: "#f5f5f5",
                  minWidth: "200px",
                  width: "20rem",
                  height: "10rem",
                  overflow: "hidden",
                  marginRight: 2,
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                  cursor: "pointer",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar
                    src={review.img}
                    alt={review.name}
                    sx={{ width: 32, height: 32 }}
                  />
                  <Box>
                    <Typography variant="subtitle1">{review.name}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {review.designation},&nbsp;{review.course}
                    </Typography>
                  </Box>
                </Box>
                <Typography
                  variant="body2"
                  sx={{ marginTop: 1, textWrap: "wrap", width: "100%" }}
                >
                  {review.body}
                </Typography>
              </Box>
            ))}
          </Marquee>
        </Box>
      </Box>
      <Box></Box>
    </Box>
  );
}

export default Testimonials;
